module.exports = __webpack_public_path__ + "static/media/8-6.aa3b69a5.mp3";